import { render } from "./worker-page.vue?vue&type=template&id=39358308"
import script from "./worker-page.vue?vue&type=script&lang=js"
export * from "./worker-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__